import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import MarketsContext from "context/MarketsContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import CreateContract from "./CreateContract";
import UserService from "services/UserService";
import axios from "axios";
import { getMarketMembershipFiles } from "services/ConfigServices";
import { membercontracts } from "variables/markets";
import { membercontractStatusDataTab } from "variables/lists/markets";
import moment from "moment";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

export default function useContractTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const marketadmin = permis.includes("markets_admin");
  const markets_update = permis.includes("markets_update");

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const marketContext = useContext(MarketsContext);
  const { market, setMarket } = marketContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getMarketMembershipFiles(chartIdGroup, market.id, 'membercontract');
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedContracts, setSelectedContracts] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `files`, []).filter(
    (item) =>
      (item.parameters.docnumber && item.parameters.docnumber.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.docname && item.parameters.docname.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.legalentity && item.parameters.legalentity.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.representedby && item.parameters.representedby.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.status && membercontractStatusDataTab.find((x) => x.id == item.parameters.status) && membercontractStatusDataTab.find((x) => x.id == item.parameters.status).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.datebegin && moment(item.parameters.datebegin).isValid() && moment(item.parameters.datebegin).format("DD/MM/YYYY").includes(filterText)) ||
      (item.parameters.dateend && moment(item.parameters.dateend).isValid() && moment(item.parameters.dateend).format("DD/MM/YYYY").includes(filterText)) ||
      (item.parameters.datesignature && moment(item.parameters.datesignature).isValid() && moment(item.parameters.datesignature).format("DD/MM/YYYY").includes(filterText)) ||
      (item.marketmembershipnumber && item.marketmembershipnumber.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.marketmembershipname && item.marketmembershipname.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = selectedContracts.map((item) => {
      let contracttoexport = {};
      contracttoexport[membercontracts.docnumber] = item.parameters.docnumber;
      contracttoexport[membercontracts.docname] = item.parameters.docname;
      contracttoexport[membercontracts.marketmembershipnumber] = item.marketmembershipnumber;
      contracttoexport[membercontracts.marketmembershipname] = item.marketmembershipname;
      contracttoexport[membercontracts.legalentity] = item.parameters.legalentity;
      contracttoexport[membercontracts.representedby] = item.parameters.representedby;
      contracttoexport[membercontracts.status] = membercontractStatusDataTab.find((x) => x.id == item.parameters.status)?.name;
      contracttoexport[membercontracts.datebegin] = (item.parameters.datebegin && moment(item.parameters.datebegin).isValid()) ? moment(item.parameters.datebegin).format("DD/MM/YYYY") : "";
      contracttoexport[membercontracts.dateend] = (item.parameters.dateend && moment(item.parameters.dateend).isValid()) ? moment(item.parameters.dateend).format("DD/MM/YYYY") : "";
      contracttoexport[membercontracts.datesignature] = (item.parameters.datesignature && moment(item.parameters.datesignature).isValid()) ? moment(item.parameters.datesignature).format("DD/MM/YYYY") : "";
      return contracttoexport;
    });
    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {markets_update && (
          <UploadButton type="button" onClick={handleClear}>
            <CreateContract refetch={refreshTable} onClick={handleClear} />
          </UploadButton>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!selectedContracts || selectedContracts.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, selectedContracts]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setSelectedContracts
  };
}
